import _ from 'lodash';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';

const TitleTyper = React.forwardRef(({
  text,
  controls,
  variants,
  initial
}, ref) => {
  const [letters, setLetters] = useState('');

  const handleUpdate = useCallback((style) => {
    const letterCount = _.get(style, '--x', 0);
    const lengthPad = letterCount === 0 ? 0 : 1;
    setLetters(text.slice(0, parseInt(letterCount, 10) + lengthPad));
  }, []);

  return (
    <motion.div
      // Don't use layout because it distorts the text rendering
      ref={ref}
      animate={controls}
      variants={variants}
      initial={initial}
      style={{
        display: 'inline'
      }}
      onUpdate={handleUpdate}
    >
      {letters}
    </motion.div>
  );
});

TitleTyper.propTypes = {
  text: PropTypes.string.isRequired,
  controls: PropTypes.shape().isRequired,
  variants: PropTypes.shape().isRequired,
  initial: PropTypes.string.isRequired
};

export default motion(TitleTyper, { forwardMotionProps: true });
